module.exports = __webpack_public_path__ + "img/save_bendi.59cdcbac.svg";